import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings → Easeedesk → Ticket priorities.
 *
 * Perechile vechi: `settings/easeedesk/ticket_priorities_settings`,
 * `get_priority_list`, `create_priority`, `update_priority`, `delete_priority`,
 * `change_priority_status`, `change_priority_urgency`, `set_priority_label`.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export interface PriorityRow {
  ID: number
  priority_name: string
  priority_color: string
  /** 1 = rand comun tuturor instantelor; nu se poate redenumi. */
  default: number
  scheme_id: number
  active: number
  urgency_flag: number
  /** Numele sub care il vede furnizorul asta; gol = numele comun. */
  label: string
}

export interface PrioritiesPage {
  default_priorities: PriorityRow[]
  custom_priorities: PriorityRow[]
}

export interface PrioritiesShell {
  title: string
  moduleUrl: string
}

export function prioritiesShellQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'ticket_priorities'],
    queryFn: () => apiGet<PrioritiesShell>('/settings/easeedesk/ticket_priorities'),
  })
}

export function prioritiesListQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'ticket_priorities', 'list'],
    queryFn: () => apiGet<PrioritiesPage>('/settings/easeedesk/ticket_priorities/list'),
  })
}

export function createPriority(priority_name: string, priority_color: string) {
  return apiPost<{ ok?: boolean; ID?: number }>('/settings/easeedesk/ticket_priorities', {
    priority_name,
    priority_color,
  })
}

export function updatePriority(priority: number, priority_name: string, priority_color: string) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/ticket_priorities/${priority}`, {
    priority_name,
    priority_color,
  })
}

export function changePriorityStatus(priority: number, on: boolean) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/ticket_priorities/${priority}/status`, {
    priority_status: on ? 'on' : 'off',
  })
}

export function changePriorityUrgency(priority: number, on: boolean) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/ticket_priorities/${priority}/urgency`, {
    priority_urgency: on ? 'on' : 'off',
  })
}

export function setPriorityLabel(priority: number, label: string) {
  return apiPost<{ ok?: boolean; label?: string }>(`/settings/easeedesk/ticket_priorities/${priority}/label`, { label })
}

export function deletePriority(priority: number) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/ticket_priorities/${priority}/remove`, {})
}
